import { Typography } from '@compass/components'
import { cn } from '@compass/utils'

import { IdentificationUrlKeys } from '../../../types'
import { CellAction } from './CellAction'
import { columnHelper } from './columnHelper'
import { Unset } from './MissingData'

const key = IdentificationUrlKeys.Url
const label = 'URL' // visitFilterLabelMap[key] // conforming the existing analytics label

const MAX_WIDTH_COLUMN_THRESHOLD = 4

export const urlColumn = () =>
  columnHelper.display({
    id: 'url',
    header: 'URL',
    cell: ({ row, table }) => {
      const url = row.original.url
      const visibleColumnCount = table.getVisibleLeafColumns().length
      const shouldLimitWidth = visibleColumnCount >= MAX_WIDTH_COLUMN_THRESHOLD

      if (!url) {
        return <Unset />
      }

      return (
        <CellAction
          copyValue={url}
          field={label}
          search={(old) => ({ ...old, [key]: url })}
          className={cn('truncate', shouldLimitWidth && 'max-w-72')}
        >
          <Typography className='text-nowrap' title={url}>
            {url}
          </Typography>
        </CellAction>
      )
    },
  })
